/* Author: Vaishnavi
Date: 19/11/2019
Issue NO:-
Description: Spacing issues fixed as per design guidelines, Removed header
*/
<template>
  <div>
    <tl-header type="h1">
      <div>Miscellaneous</div>
    </tl-header>
    <!-- "['Import UDF', 'FBP Bands', 'Retirement Settings','SMTP Configuration', 'Probation Settings', 'Form 24Q', 'Login Settings']" -->
    <div>
      <!-- <tl-stepper
        :heading="['Import UDF', 'SMTP Configuration', 'Form 24Q']"
        :current="current"
        @currentStepper="goToStep(0)"></tl-stepper> -->

      <div v-if="showUdf">
        <import-udf
          @skip="skipLoginSettings()"
          @previous="previousUdf()"
          @next="skipLoginSettings()"
        />
      </div>

      <!-- <div v-if="fbpBand || $route.params.stepindex == 1">
        <fbp-band
          @skip="goToStep(2)"
          @previous="goToStep(0)"
          @next="goToStep(2)"
        />
      </div>

      <div v-if="showRetirementSettings">
        <retirement-settings
          @skip="goToStep(3)"
          @previous="goToStep(1)"
          @next="goToStep(3)"
        />
      </div> -->

      <div v-if="showSmtpConfiguration">
        <smtp-configuration
          @skip="goToStep(5)"
          @previous="goToStep(0)"
          @next="goToStep(5)"
        />
      </div>

      <!-- <div v-if="showProbationSettings">
        <probation-settings
          @skip="goToStep(5)"
          @previous="goToStep(3)"
          @next="goToStep(5)"
        />
      </div> -->

      <div v-if="showFormQ">
        <form-q
          @skip="skipLoginSettings()"
          @previous="goToStep(1)"
          @next="skipLoginSettings()"
        />
      </div>
      <!--
      <div v-if="showLoginSettings">
        <login-settings
          @skip="skipLoginSettings()"
          @previous="goToStep(5)"
          @next="skipLoginSettings()"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import ImportUdf from "./importUdf.vue";
import FbpBand from "./fbpBand.vue";
import TlStepper from "@/components/stepper/TlStepper.vue";
import RetirementSettings from "./retirementSettings.vue";
import SmtpConfiguration from "./smtpConfiguration.vue";
import ProbationSettings from "./probationSettings.vue";
import FormQ from "./form24Q.vue";
import LoginSettings from "./loginSettings.vue";

import {
  mapGetters,
  mapActions
} from 'vuex';

export default {
  name: 'Misc',
  components: {
    FbpBand,
    ImportUdf,
    TlStepper,
    RetirementSettings,
    SmtpConfiguration,
    ProbationSettings,
    FormQ,
    LoginSettings
  },
  data() {
    return {
      current: 0,
      showUdf: true,
      fbpBand: false,
      showRetirementSettings: false,
      showSmtpConfiguration: false,
      showProbationSettings: false,
      showFormQ: false,
      showLoginSettings: false,
    }
  },
  computed:{
    ...mapGetters({
       getleid:'onboard/legal_entities/legal_entity_ID',
      //  getdata: 'onboard/statutory/getData'
    }),
    le_id(){
      if(this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index)
      else{
        if(this.getleid(0)){
          return this.getleid(0)
         } else{
           this.fetchFbpBands()
           return this.getleid(0)
         }
      }
    }
  },
  activated(){
    this.getFBPBands()
  },
  mounted(){
    this.getFBPBands()
  },
  methods: {
    ...mapActions("onboard/statutory/", {
      act_fetchAll: "fetchAll",
      act_create: "create"
    }),
    goToStep(currentVal) {
      if (!currentVal || currentVal < 0 || currentVal > 6) {
        currentVal = 0;
      }
      this.showUdf = false;
      this.fbpBand = false;
      this.showRetirementSettings = false;
      this.showSmtpConfiguration = false;
      this.showProbationSettings = false;
      this.showFormQ = false;
      this.showLoginSettings = false;
      this.current = currentVal;

      if(currentVal == 0) {
        this.showUdf = true;
      }

      // if(currentVal == 1) {
      //   this.fbpBand = true;
      // }
      //
      // if(currentVal == 2) {
      //   this.showRetirementSettings = true;
      // }

      if(currentVal == 1) {
        this.showSmtpConfiguration = true;
      }

      if(currentVal == 4) {
        this.showProbationSettings = true;
      }

      if(currentVal == 5) {
        this.showFormQ = true;
      }

      if(currentVal == 6) {
        this.showLoginSettings = true;
      }
    },
    goToIntro() {
      this.$emit('displayIntro');
    },
    async fetchFbpBands() {
      try {
        await this.act_fetchAll(this.le_id);
      } catch (err) {
        //console.log(err);
      }
    },

    getFBPBands() {
      if(this.$route.query.stepindex) {
        this.current = this.$route.query.stepindex;
        if(this.current) {
          this.goToStep(this.current);
        }
        this.goToStep(1);
        // to remove stepindex from query using loadash
        let newRouteQuery = _.omit();
        this.$router.replace( newRouteQuery  );
      } else {
        this.goToStep(0);
      }
    },
    previousUdf() {
      this.$router.push({
        path: `/onboarding/entity/${
            this.$route.params.entity_index
          }/bands`
        });
    },
    skipLoginSettings() {
      this.$router.push({
        path: `/onboarding/entity/${
            this.$route.params.entity_index
          }/preferences`
        });
    }
  }
}
</script>

<style scoped>
.placeAtEnd {
  margin-top: 150px;
}
.showIntro {
  cursor: pointer;
}
.retirement-margin {
  margin-left: 35px;
}
.smtp-margin {
  margin-left: 30px;
}
</style>
